import {SchemaDom} from "/@lib@/edit/schema/schema.js";
import {IAutoFillAsyncMgr, IAutofillAsyncRule} from "/@lib@/edit/schema/schemaMeta.js";
import {IWspXmlHouse} from "/@lib@/wsp/wspsLive.js";
import {IReg} from "/@lib@/commons/registry.js";
import {IUniverseEnv, UNIVERSE} from "/@lib@/core/universe.js";
import {ChainUniverse} from "/@lib@/wsp/chain.js";

class IdGenAsyncMgr implements IAutoFillAsyncMgr {

	//public schemaDom: SchemaDom;

	constructor(public svc: string, public cdaction?: string, public params?: Dict<any>, public universe?: ChainUniverse) {
		//this.schemaDom = schemaDom
	}

	needNewVal(schemaDom: SchemaDom, nodeOrAttr: Node | Attr, rule: IAutofillAsyncRule): boolean {
		const house = schemaDom.house as IWspXmlHouse;
		if (!house.wsp.reg.hasPermission("write.node.update", house.srcFields.srcRoles, this.universe.auth.currentUser.isSuperAdmin, house.srcFields.srcRi)) return false;
		return nodeOrAttr instanceof Attr ? !nodeOrAttr.nodeValue : !nodeOrAttr.textContent;
	}

	async newValue(schemaDom: SchemaDom, nodeOrAttr: Node | Attr, rule: IAutofillAsyncRule): Promise<string | null> {
		let itemType = (schemaDom.house as IWspXmlHouse).itemType;
		if (!itemType) {
			//attente de la fin de l'init du doc.
			await Promise.resolve();
			itemType = (schemaDom.house as IWspXmlHouse).itemType;
		}
		return this.fetchValue(itemType.reg);
	}

	async fetchValue(reg: IReg<IUniverseEnv>): Promise<string> {
		const univ = this.universe || reg.env.universe;
		const val = (await univ.httpFrames.web.fetchSvcJson<JIdGenResp>(this.svc, this.cdaction, this.params)).nextValue;
		if (typeof val === "string") return val;
		if (typeof val === "number") return val.toString();
		return null;
	}
}

interface JIdGenResp {nextValue: string | number}

export const crossDomMgrFactory = (config: Element) => (/*schemaDom: SchemaDom*/) => {
	const univ = config.getAttribute("universe");
	const universe = univ ? UNIVERSE.all.get(univ) as ChainUniverse : null;
	const p = config.getAttribute("params");
	return new IdGenAsyncMgr(config.getAttribute("svc"), config.getAttribute("cdaction"), p ? JSON.parse(p) : null, universe);
}